import type { Edge, Node } from '@xyflow/react';

export type GraphSnapshot = {
  name: string;
  nodes: Node[];
  edges: Edge[];
};

export type GraphHistory = {
  past: GraphSnapshot[];
  future: GraphSnapshot[];
};

const withoutCallbacks = (_key: string, value: unknown) => typeof value === 'function' ? undefined : value;

export const createGraphSnapshot = (name: string, nodes: Node[], edges: Edge[]): GraphSnapshot => JSON.parse(JSON.stringify({
  name,
  nodes: nodes.map(({ id, type, position, data }) => ({ id, type, position, data })),
  edges: edges.map(({ selected, ...edge }) => edge),
}, withoutCallbacks));

export const pushGraphHistory = (history: GraphHistory, snapshot: GraphSnapshot, limit: number): GraphHistory => ({
  past: [...history.past, snapshot].slice(-limit),
  future: [],
});
